(function () {
	'use strict';

	angular.module('mx.components').component('mxFileUploader', {
		bindings: {
			files: '=?',
		},
		controller: MxFileUploaderCtrl,
		controllerAs: 'vm',
		templateUrl: 'mx-file-uploader/mx-file-uploader.html',
	});

	function MxFileUploaderCtrl() {
		var vm = this;

		vm.$onInit = function () {
			vm.files = vm.files || [];

			vm.filesSelected = filesSelected;
			vm.removeFile = removeFile;
		};

		return vm;

		function filesSelected(files) {
			if (!files || !files.length) {
				return;
			}
			for (var i = 0; i < files.length; i++) {
				vm.files.push(files[i]);
			}
		}

		function removeFile(file) {
			var index = vm.files.indexOf(file);
			if (index !== -1) {
				vm.files.splice(index, 1);
			}
		}
	}
})();
